import classNames from 'classnames';

import { PriceFormatter } from '../../../app/shared/common';
import css from './Price.css';

interface PriceProps {
  amount: number;
  className?: string;
}

const Price = ({ amount, className }: PriceProps) => {
  return <span className={classNames(css.root, className)}>{PriceFormatter.format(amount, false)}</span>;
};

export default Price;
